export default "__VITE_ASSET__BMUh7io0__"